/* eslint-disable import/prefer-default-export */
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
export function initGTM() {
  const id = process.env.REACT_APP_GTM_ID;
  if (!id) return;

  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });

    const f = d.getElementsByTagName(s)[0];
    const j = d.createElement(s);
    j.async = true;
    j.src = `https://www.googletagmanager.com/gtm.js?id=${i}`;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', id);
}
